import React from 'react';
import './Music.css';
import albumCover1 from '../images/Shapeofyou.jpeg'; 
import albumCover2 from '../images/AnimalsM5.jpeg'; // Back in Black by AC/DC
import albumCover3 from '../images/Lovemelikeyou.jpeg'; // Appetite for Destruction by Guns N' Roses

const favoriteGenres = ["Rock", "Classic Rock", "Hard Rock", "Pop", "Blues", "Alternative"];
const favoriteAlbums = [
  { title: "Shape of You", artist: "Ed sheeran", imgSrc: albumCover1 },
  { title: "Animals", artist: "Maroon 5", imgSrc: albumCover2 },
  { title: "Love Me Like You Do", artist: "Ellie Goulding", imgSrc: albumCover3 },
];

const Music: React.FC = () => {
  return (
    <div className="music-page">
      <div className="quote">
        <p>“Rock and Roll isn’t a genre, it’s a way of life.” 🎸</p>
      </div>

      <div className="genre-section">
        <h3>Explore by Genre</h3>
        <div className="genres">
          {favoriteGenres.map((genre, index) => (
            <div key={index} className="genre-card" style={{ animationDelay: `${index * 0.2}s` }}>
              <p>{genre}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="albums-section">
        <h3>Favorite Albums</h3>
        <div className="albums">
          {favoriteAlbums.map((album, index) => (
            <div key={index} className="album-card" style={{ animationDelay: `${index * 0.3}s` }}>
              <img src={album.imgSrc} alt={album.title} className="album-image" />
              <div className="album-details">
                <h4>{album.title}</h4>
                <p>by {album.artist}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Music;
